import { setItem, getItem, removeItem } from './secureStorage';

/**
 * Key prefix so everything related to scope-input persistence lives under the
 * same namespace in storage.  This lets us bulk-delete with a single filter
 * later and avoids accidental key collisions.
 */
const PREFIX = 'scope_';

/**
 * Retrieve a single custom-input field value.
 */
export function getField(key: string): string | null {
  return getItem(`${PREFIX}${key}`);
}

/**
 * Persist a custom-input field value.
 */
export function setField(key: string, value: string): void {
  setItem(`${PREFIX}${key}`, value);
}

/**
 * Remove a specific custom-input entry.
 */
export function clearField(key: string): void {
  removeItem(`${PREFIX}${key}`);
}

/**
 * Convenience helper for wiping an entire group of keys.
 */
export function clearAll(keys: string[]): void {
  keys.forEach(k => clearField(k));
}
